"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSavingsVault__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "depositCap",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "depositFill",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "DepositCapExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "DepositForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxDeposit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxMint",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxRedeem",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxWithdraw",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawnFailed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key",
                type: "bytes32",
            },
        ],
        name: "EnumerableMapNonexistentKey",
        type: "error",
    },
    {
        inputs: [],
        name: "InitializedAlready",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "decimals",
                type: "uint8",
            },
        ],
        name: "InvalidDecimals",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "InvalidDepositTimeRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "InvalidStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
        ],
        name: "InvalidWithdrawableTime",
        type: "error",
    },
    {
        inputs: [],
        name: "MoveForbidden",
        type: "error",
    },
    {
        inputs: [],
        name: "MovedAlready",
        type: "error",
    },
    {
        inputs: [],
        name: "NoReward",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "NonexistentStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInDepositPeriod",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInWithdrawPeriod",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyFactory",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "SafeERC20FailedOperation",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "decimals",
                type: "uint256",
            },
        ],
        name: "CoinAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "Deposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                internalType: "contract IStableCoin",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "coins",
        outputs: [
            {
                internalType: "contract IStableCoin[]",
                name: "_coins",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
        ],
        name: "coinsExists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "coinsLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                internalType: "contract IStableCoin[]",
                name: "_coins",
                type: "address[]",
            },
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
        ],
        name: "constructor2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "convertToAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "convertToShares",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
        ],
        name: "decimalsOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "deposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "depositBeginTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositEndTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "depositFill",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "emergencyWithdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hasMoved",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_depositCap",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "maxDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "maxMint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "maxRedeem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "maxWithdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "moveToTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "previewDeposit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "previewMint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "previewRedeem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "previewWithdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "redeem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardAsset",
        outputs: [
            {
                internalType: "contract IStableCoin",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_depositCap",
                type: "uint256",
            },
        ],
        name: "setDepositCap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "withdrawableTime",
                type: "uint256",
            },
        ],
        name: "setTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "total",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "treasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "withdrawableTime",
                type: "uint256",
            },
        ],
        name: "updateTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "withdraw",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawableBeginTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class MockSavingsVault__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_factory, overrides) {
        return super.getDeployTransaction(_factory, overrides || {});
    }
    deploy(_factory, overrides) {
        return super.deploy(_factory, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.MockSavingsVault__factory = MockSavingsVault__factory;
